import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";

export default function Callback() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-ink-500">
        Completing sign-in…
      </div>
    );
  }
  if (auth.error) {
    return (
      <div className="flex min-h-screen items-center justify-center text-danger">
        {auth.error.message}
      </div>
    );
  }
  return <Navigate to="/" replace />;
}
